module.exports = __webpack_public_path__ + "assets/img/旗标.ebb3a0f5.png";